// src/pages/ForgotPassword.js
import React, { useState } from 'react'
import { Box, Container, Paper, Typography, TextField, Button, Alert, Stack } from '@mui/material'
import { useNavigate } from 'react-router-dom'

const ForgotPassword = () => {
    const navigate = useNavigate()
    const [email, setEmail] = useState('')
    const [sent, setSent] = useState(false)

    const handleSubmit = (e) => {
        e.preventDefault()
        // Dummy behavior for now. Hook it to your backend later.
        setSent(true)
    }

    return (
        <Box sx={{ minHeight: '100vh', py: 8 }}>
            <Container maxWidth="sm">
                <Paper
                    elevation={0}
                    sx={{
                        p: 4,
                        borderRadius: 4,
                        bgcolor: 'background.paper',
                        border: '1px solid rgba(255,255,255,0.1)',
                    }}
                >
                    <Typography variant="h4" fontWeight="bold" sx={{ mb: 1 }}>
                        Reset password
                    </Typography>
                    <Typography color="text.secondary" sx={{ mb: 3 }}>
                        Enter your email and we�ll send a reset link.
                    </Typography>

                    {sent && (
                        <Alert severity="success" sx={{ mb: 3 }}>
                            If an account exists for that email, a reset link will be sent.
                        </Alert>
                    )}

                    <form onSubmit={handleSubmit}>
                        <TextField
                            fullWidth
                            label="Email Address"
                            type="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            sx={{ mb: 2 }}
                        />

                        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                            <Button variant="outlined" onClick={() => navigate('/login')}>
                                Back to login
                            </Button>
                            <Button type="submit" variant="contained">
                                Send reset link
                            </Button>
                        </Stack>
                    </form>
                </Paper>
            </Container>
        </Box>
    )
}

export default ForgotPassword
